import React, { useRef, useEffect, useState } from 'react';
import './SociosSection.css';

const socios = [
  { nombre: 'ARCHTISTICS', logo: '/images/socios/ARCHTISTICS.png' },
  { nombre: 'Automatiza WhatsApp', logo: '/images/socios/Automatiza WhatsApp.png' },
  { nombre: 'Canavi Uniformes', logo: '/images/socios/canavi_uniformes.jpeg' },
  { nombre: 'CIMA Business Center', logo: '/images/socios/CIMA.jpeg' },
  { nombre: 'Ciudad Maderas', logo: '/images/socios/ciudad_maderas.png' },
  { nombre: 'Hidroteam', logo: '/images/socios/Hidroteam.png' },
  { nombre: 'Infectología CMNO', logo: '/images/socios/INFECTOLOGIA_CMNO.jpg' },
  { nombre: 'Promo Minuto Morelia', logo: '/images/socios/Promo_minuto.png' },
  { nombre: 'Reserva Tour', logo: '/images/socios/Reservatur.jpg' },
  { nombre: 'Sigue la Noche', logo: '/images/socios/SIGUE LA NOCHE.png' },
  { nombre: 'SINA', logo: '/images/socios/SINA .png' },
  { nombre: 'TiendaMax', logo: '/images/socios/tiendamax.png' }
];

function useOnScreen(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      { threshold: 0.3 }
    );
    const currentRef = ref.current;
    if (currentRef) observer.observe(currentRef);
    return () => { if (currentRef) observer.unobserve(currentRef); };
  }, [ref]);
  return isIntersecting;
}

function SocioCard({ socio, index }) {
  const cardRef = useRef();
  const isVisible = useOnScreen(cardRef);
  const [hasAnimated, setHasAnimated] = useState(false);

  useEffect(() => {
    if (isVisible && !hasAnimated) {
      setHasAnimated(true);
    } else if (!isVisible && hasAnimated) {
      setHasAnimated(false);
    }
  }, [isVisible, hasAnimated]);

  return (
    <div 
      ref={cardRef}
      className={`socio-card ${hasAnimated ? 'socio-animated' : ''}`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="socio-logo-container">
        <img 
          src={socio.logo} 
          alt={`Logo ${socio.nombre}`}
          title={socio.nombre}
          className="socio-logo"
          draggable="false"
        />
      </div>
    </div>
  );
}

export default function SociosSection() {
  return (
    <section className="socios-section">
      <h3 className="socios-titulo">
        NUESTROS SOCIOS
      </h3>
      <div className="socios-grid">
        {socios.map((socio, index) => (
          <SocioCard 
            key={socio.nombre} 
            socio={socio} 
            index={index}
          />
        ))}
      </div>
    </section>
  );
}
